export default __webpack_public_path__ + "static/media/hdr-high.851c9c1b.png";